export var FuelType;
(function (FuelType) {
    FuelType["GASOLINE"] = "GASOLINE";
    FuelType["DIESEL"] = "DIESEL";
    FuelType["ELECTRIC"] = "ELECTRIC";
    FuelType["GAS"] = "GAS";
})(FuelType || (FuelType = {}));
export var CarCondition;
(function (CarCondition) {
    CarCondition["NEW"] = "NEW";
    CarCondition["USED"] = "USED";
})(CarCondition || (CarCondition = {}));
export var NumberCylinders;
(function (NumberCylinders) {
    NumberCylinders["DOS"] = "2";
    NumberCylinders["TRES"] = "3";
    NumberCylinders["CUATRO"] = "4";
    NumberCylinders["CINCO"] = "5";
    NumberCylinders["SEIS"] = "6";
    NumberCylinders["OCHO"] = "8";
    NumberCylinders["DIEZ"] = "10";
    NumberCylinders["DOCE"] = "12";
    NumberCylinders["DIECISEIS"] = "16";
})(NumberCylinders || (NumberCylinders = {}));
